import { configureStore } from './configureStore';
import assignReducer from '../reducers/assign';

const assignModalStore = (initialState = {}) =>
  configureStore(initialState, assignReducer, {
    combine: false,
    name: 'AssignModal',
  });

export default assignModalStore;
